import api from './api';

// ?courseId=… добавляем только если курс задан (иначе бэкенд берёт первый активный)
const cq = (courseId) => (courseId ? `?courseId=${courseId}` : '');

// Course
export const getMyCourses = async () => {          // все курсы ученика (для переключателя)
  const response = await api.get('/student/courses');
  return response;
};

export const getMyCourse = async (courseId) => {
  const response = await api.get(`/student/course${cq(courseId)}`);
  return response;
};

export const getCoursePage = (courseId) => api.get(`/student/course-page/${courseId}`);

export const getSections = async (courseId) => {
  const response = await api.get(`/student/sections${cq(courseId)}`);
  return response;
};

export const getProgress = async (courseId) => {
  const response = await api.get(`/student/progress${cq(courseId)}`);
  return response;
};

// Хронология активности (для «Недавняя активность» + «Вся история»)
export const getActivity = async (courseId) => {
  const response = await api.get(`/student/activity${cq(courseId)}`);
  return response;
};

// Шкала перевода баллов курса (для попапа в «Вариантах»)
export const getScoreScale = async (courseId) => {
  const response = await api.get(`/student/score-scale${cq(courseId)}`);
  return response;
};

export const getPendingHomeworks = async (courseId) => {
  const response = await api.get(`/student/pending${cq(courseId)}`);
  return response;
};

export const getVariants = async (courseId) => {   // пробники курса
  const response = await api.get(`/student/variants${cq(courseId)}`);
  return response;
};

// Lessons
// Картинка из условия урока байтами — для PDF-бланка (напрямую хранилища её не отдают)
export const getLessonImage = (lessonId, url) =>
  api.get(`/student/lessons/${lessonId}/image`, { params: { url }, responseType: 'arraybuffer' });

export const getLesson = async (id) => {
  const response = await api.get(`/student/lessons/${id}`);
  return response;
};

export const viewLesson = async (id) => {
  const response = await api.post(`/student/lessons/${id}/view`);
  return response;
};

// Homeworks
export const getHomeworks = async (courseId) => {
  const response = await api.get(`/student/homeworks${cq(courseId)}`);
  return response;
};

export const getLessonHomeworks = async (lessonId) => {
  const response = await api.get(`/student/homework/lesson/${lessonId}`);
  return response;
};

export const submitAnswer = async (homeworkId, data) => {
  const response = await api.post(`/student/homeworks/${homeworkId}/answer`, data);
  return response;
};

export const uploadHomeworkImage = async (homeworkId, formData) => {
  const response = await api.post(`/student/homeworks/${homeworkId}/image`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response;
};

// Submit all answers at once
export const submitAllAnswers = async (answers) => {
  const response = await api.post('/student/homeworks/submit-all', { answers });
  return response;
};

// Finish lesson (submit all answers)
export const finishLesson = async (lessonId, answers) => {
  const response = await api.post(`/student/lessons/${lessonId}/finish`, { answers });
  return response;
};

// Начать повторную попытку ДЗ/варианта, которую выдал куратор
export const startRetry = (lessonId) => api.post(`/student/lessons/${lessonId}/retry`);

// Get personal Zoom join URL (server validates time window + logs access)
export const joinLesson = async (lessonId) => {
  const response = await api.post(`/student/lessons/${lessonId}/join`);
  return response;
};
// Индивидуальный код ученика (для родительского просмотра успеваемости по коду)
export const getProgressCode = () => api.get('/student/progress-code');

// Короткий код для реферальной ссылки (/r/<код>)
export const getInviteCode = () => api.get('/student/invite-code');

/* Файл к решению номера с ручной проверкой. Возвращает { url, name, size } —
   этот же объект уходит обратно вместе с ответом. */
export const uploadAnswerFile = (homeworkId, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`/student/homeworks/${homeworkId}/file`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
};
